import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
//import resolveIcon from '../../images/resolved.png';
// import cross from '../../images/cross.png';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { authKey, GET_CHIPPING_HEAP_NUMBER_LIST, GET_STAKEHOLDER_CATEGORY } from '../../../common/URLs';

import jwt from 'jwt-decode';
import { Row, Col, NavItem, Table } from 'react-bootstrap';
import { Container, Box, Button, TextField, Typography, Checkbox, Grid } from '@mui/material';
import { NO_DATA_AVAILABLE } from '../../../common/constants';
import { DataGrid } from '@mui/x-data-grid';
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import Moment from 'moment';
import { loaderService } from "../../../common/custom-loader/loader-service";
import { getLocalStorageItem } from '../../../common/localStorageUtils';
import { toast } from 'react-toastify';
import { PIT_ROLES } from "../../../common/constants";
import { CheckBox } from '@mui/icons-material';
import { weightValidation } from '../../../common/commonValidations';
import { handleNumberFieldFocus } from '../../../common/commonFunction';
import apiClient from '../../../axios';


function HeapPopOver(props) {

  const [stakeUrnType, setStakeUrnType] = useState(props.pickupUrnType)
  const [heapDetails, setHeapDetails] = useState();
  const [schedulePickupWeight, setScedulePickupWeight] = useState(props.scheduledWeight);
  const [totalWeight, setTotalWeight] = useState();
  const [stakeholderDetails, setStakeholderDetails] = useState();
  const { pickupQuantity, setPickupQuantity, computed, setComputed } = props;

  useEffect(() => {
    setPickupQuantity(props?.vehicleCapacity);
  }, [props?.vehicleCapacity]);
  const decoded = jwt(getLocalStorageItem('id_token'));
  const [pickupWeight, setPickupWeight] = useState({
    "rbCbWeight": ""
  });
  const [errorMessage, setErrorMessage] = useState({
    rbCbWeightError: "",
    totalWeightError: "",
    pickupQuantity: ""
  });
  const [newArrayList, setNewArrayList] = useState(props.newArrayList);

  const urn = (localStorage.getItem('role') == PIT_ROLES.PitScmUser || stakeholderDetails?.category == 'Transporter') ? stakeUrnType?.sourceStakeholderUrn : decoded.extension_URN
  const type = (localStorage.getItem('role') == PIT_ROLES.PitScmUser || stakeholderDetails?.category == 'Transporter') ? stakeUrnType?.sourceType : stakeholderDetails?.category

  useEffect(() => {

    if (urn && type) {
      getChippingHeapList();
    }
  }, [urn, type]);


  useEffect(() => {
    if (props.heapsList != null) {
      setHeapDetails(props.heapsList);
    } else if (decoded.extension_URN) {
      getStakeDetails();
    }
  }, [decoded.extension_URN]);

  function getStakeDetails() {
    loaderService.showLoader()
    apiClient
      .post(GET_STAKEHOLDER_CATEGORY,
        {
          "urn": decoded.extension_URN,
          "type": ""
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setStakeholderDetails(response.data);
        //getChippingHeapList(response.data.category);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader()
        toast.error(error.message);
      });
  }

  const getChippingHeapList = (category) => {
    loaderService.showLoader()
    apiClient
      .post(
        GET_CHIPPING_HEAP_NUMBER_LIST,
        {
          "stakeholderUrn": urn,
          "stakeHolderType": type,
          "sourceStakeholderPO": props?.pickupUrnType?.sourceStakeholderPo
        },
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem('id_token'),
          },
        },
        null
      )
      .then((response) => {
        response.data.chippingHeapNumberList.forEach(chip => {
          newArrayList.forEach(selectedVal => {
            if (selectedVal.bundleId === chip.heapNumber || selectedVal.heapNumber === chip.heapNumber) {
              chip.isSelected = true;
              chip.rbCbWeight = selectedVal.rbCbWeight;
            }
          }
          )
        })
        setHeapDetails(response.data.chippingHeapNumberList);
        loaderService.hideLoader()
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader()
        toast.error(error.message);
      });
  };

  const plantSubmit = (e) => {
    props.heapSubmitCallbackFunction(heapDetails);
    props.handleLogModalClose()
  }
  const bambooSubmit = (e) => {
    // let error = false;
    // heapDetails.forEach(heap => {
    //   if (heap?.isSelected) {
    //     if (!heap?.rbCbWeight || heap?.rbCbWeight > heap?.bundleSelectionBalanceQuantity) {
    //       error = true;
    //     }
    //   }
    // })

    // if (error) {
    //   setErrorMessage({ ...errorMessage, rbCbWeightError: "Please enter Pick-up quantity of selected heap number" })
    // }
    //  else if(schedulePickupWeight < totalWeight) {

    //   setErrorMessage({ ...errorMessage, totalWeightError: "Total Pick-up quantity should not be greater than Scheduled Pick-up weight" })

    //  }
    if (!pickupQuantity) {
      setErrorMessage({ ...errorMessage, pickupQuantity: "Please enter Pick-up quantity" });
    }
    else if (pickupQuantity > props?.vehicleCapacity) {
      setErrorMessage({ ...errorMessage, pickupQuantity: "Pickup quantity cannot be more than vehicle capacity" })
    }
    else if (!computed) {
      setErrorMessage({ ...errorMessage, rbCbWeightError: "Please compute Pick-up quantity to be taken from below heaps" });
    }
    // else if(totalBalanceQuantity < pickupQuantity) {
    //   setErrorMessage({ ...errorMessage, rbCbWeightError: 'Insufficient balance quantity from below heaps to meet the required pick-up quantity.' });
    // }
    else {
      props.allocateHeapFunction(heapDetails);
      props.handleLogModalClose();
    }
  }

  const handlePickupQuantity = (e) => {
    setComputed(false);
    weightValidation(e.target.value) && setPickupQuantity(e.target.value);
    if (e.target.value <= props?.vehicleCapacity) {
      setErrorMessage({ ...errorMessage, pickupQuantity: "" })
    }
    else setErrorMessage({ ...errorMessage, pickupQuantity: "Pickup quantity cannot be more than vehicle capacity" })
  }

  const handleChange = (e, row) => {
    // const limit = 6;
    let heapList = [...heapDetails]
    heapList.forEach(inv => {
      if (inv.heapNumber === row.heapNumber && weightValidation(e.target.value)) {
        inv.rbCbWeight = e.target.value;
      }
    })
    setHeapDetails(heapList);
    //setHeapDetails(heapList);
    //   let totalWeight = heapDetails.reduce((total, bundle) =>
    // total = total + (bundle.checkVal ? Number(bundle.rbCbWeight) : 0)
    // , 0)
    // setTotalWeight(totalWeight);

    weightValidation(e.target.value) && setPickupWeight({ ...pickupWeight, 'rbCbWeight': e.target.value });

    // if (e.target.value.length > e.target.maxLength)
    //   e.target.value = e.target.value.slice(0, e.target.maxLength);

    if (e.target.name === "rbCbWeight") {
      setErrorMessage({ ...errorMessage, rbCbWeightError: "" });
    }
  }

  //   const handleCheckboxChange = (event, rowId) => {
  //     const newRows = rows.map(row => ({ ...row })); // Create a shallow copy of the rows array
  //     const isChecked = event.target.checked;
  //     // Find the index of the row being changed
  //     const currentIndex = newRows.findIndex((row) =>
  //  row.id
  //  === rowId);
  //     if (isChecked) {
  //       // Select the current row and enable the next one
  //       newRows[currentIndex].isSelected = true;
  //       if (currentIndex + 1 < newRows.length) {
  //         newRows[currentIndex + 1].isDisabled = false;
  //       }
  //     } else {
  //       // Unselect the current row and all subsequent rows, and disable them
  //       for (let i = currentIndex; i < newRows.length; i++) {
  //         newRows[i].isSelected = false;
  //         if (i > currentIndex) {
  //           newRows[i].isDisabled = true;
  //         }
  //       }
  //     }
  //     // Update the state with the modified rows array
  //     setRows(newRows);
  //   };

  const checkVal = (e, heapDetail) => {
    if (props.heapsList != null) {
      let heapList = [...heapDetails]
      heapList.forEach(inv => {
        if (inv.bundleId === heapDetail.bundleId && inv.id === heapDetail.id) {
          inv.isSelected = inv.isSelected ? false : true;
        }
      })
      setHeapDetails(heapList);
    } else {
      let heapList = [...heapDetails]
      heapList.forEach(inv => {
        if (inv.heapNumber === heapDetail.heapNumber) {
          inv.isSelected = inv.isSelected ? false : true;
          inv.bundleId = inv.heapNumber;
          inv.avgMoisture = inv.postChippingMoisture;
        }
      })
      setHeapDetails(heapList);
    }
  }

  const columns = [
    // {
    //   field: 'rowSelect', // Change this to the actual ID field name
    //   headerName: '',
    //   width: 60,
    //   renderCell: (params) => (
    //     <Checkbox checked={params.row.isSelected}
    //     />
    //   ),
    // },
    {
      field: 'heapNumber', headerName: 'Heap No.', width: 230,
      valueGetter: (params) => {
        return params.row.heapNumber ? params.row.heapNumber : params.row.bundleId
      }
    },
    {
      field: 'chippingQuantity', headerName: 'Chipping Quantity (MT)', width: 200,
    },
    {
      field: 'balanceQuantity', headerName: 'Actual Balance Quantity (MT)', width: 200,
      valueGetter: (params) => {
        return params.row.balanceQuantity ? params.row.balanceQuantity : params.row?.pickupWeight
      }
    },
    {
      field: 'bundleSelectionBalanceQuantity', headerName: 'Bundle Selection Balance Quantity (MT)', width: 200,
      valueGetter: (params) => {
        return params.row.bundleSelectionBalanceQuantity ? params.row.bundleSelectionBalanceQuantity : params.row?.pickupWeight
      }
    },
    {
      field: 'rbCbWeight', headerName: 'Pick-up Quantity(in MT)', width: 310,
      valueGetter: (params) => {
        return params.row.rbCbWeight && Number(params.row.rbCbWeight)?.toFixed(4)
      }
      // renderCell: (params) => {
      //   return (
      //     <>
      //       {props.heapsList == null &&
      //         <TextField size='small' variant='standard'
      //           // required
      //           error={params.row.rbCbWeight > params.row.bundleSelectionBalanceQuantity}
      //           helperText={params.row.rbCbWeight > params.row.bundleSelectionBalanceQuantity ? "Pick-up quantity cannot be more than balance quantity" : ""}
      //           type="number"
      //           onFocus={handleNumberFieldFocus}
      //           value={params.row.rbCbWeight}
      //           name='rbCbWeight'
      //           onChange={(e) => handleChange(e, params.row)}
      //           onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '-' || evt.key === '+') && evt.preventDefault()}
      //         // inputProps={{
      //         //   maxLength: 6
      //         // }}
      //         />}
      //     </>
      //   )
      // }
    },
    {
      field: 'postChippingMoisture', headerName: 'Average Moisture', width: 200,
      valueGetter: (params) => {
        return params.row.postChippingMoisture ? params.row.postChippingMoisture : params.row?.pickupMoisture
      }
    },


  ];


  const columns2 = [
    {
      field: 'rowSelect', // Change this to the actual ID field name
      headerName: '',
      width: 60,
      renderCell: (params) => (
        <Checkbox name="rowSelect" onChange={(e) => checkVal(e, params.row)} checked={params.row.isSelected} />
      ),
    },
    {
      field: 'heapNumber', headerName: 'Heap No.', width: 230,
      valueGetter: (params) => {
        return params.row.heapNumber ? params.row.heapNumber : params.row.bundleId
      }
    },
    {
      field: 'pickupWeight', headerName: 'GRN Weight', width: 150,
    },
    {
      field: 'pickupMoisture', headerName: 'Moisture', width: 150,
    },
  ];

  const allocateQuantity = () => {
    const totalBalanceQuantity = heapDetails?.reduce((accumulator, currentItem) => {
      return accumulator + currentItem.bundleSelectionBalanceQuantity;
    }, 0)
    if (!pickupQuantity) {
      setErrorMessage({ ...errorMessage, pickupQuantity: "Please enter Pick-up quantity" });
    }
    else if (pickupQuantity > props?.vehicleCapacity) {
      setErrorMessage({ ...errorMessage, pickupQuantity: "Pickup quantity cannot be more than vehicle capacity" });
    }
    else if (totalBalanceQuantity < pickupQuantity) {
      setErrorMessage({ ...errorMessage, rbCbWeightError: 'Insufficient balance quantity from below heaps to meet the required pick-up quantity.' });
    }
    else {
      setComputed(true);
      setErrorMessage({ ...errorMessage, rbCbWeightError: "" });
      let remainingQuantity = pickupQuantity;
      const updatedRows = [...heapDetails];
      for (let i = 0; i < updatedRows.length; i++) {
        const currentRow = updatedRows[i];
        if (remainingQuantity > 0) {
          if (currentRow.bundleSelectionBalanceQuantity > 0) {
            const allocatedQuantity = Math.min(currentRow.bundleSelectionBalanceQuantity, remainingQuantity);
            updatedRows[i] = {
              ...currentRow,
              rbCbWeight: allocatedQuantity
            };
            remainingQuantity -= allocatedQuantity;
          }
        }
        else {
          updatedRows[i] = {
            ...currentRow,
            rbCbWeight: null
          };
        }
      }
      setHeapDetails(updatedRows);
    }
  };

  return (
    <>
      <Container maxWidth="xxl">
        <Typography variant="h5" gutterBottom>
          Heap Details
        </Typography>
        {props.heapsList == null && <Grid container spacing={1}>
          <Grid item xs={12} lg={6}>
            <TextField fullWidth size="small" label='Vehicle Capacity(in MT)' type="text" value={props?.vehicleCapacity || ''} disabled />
          </Grid>
          <Grid item xs={12} lg={6}>
            <TextField fullWidth size='small' sx={{ marginLeft: "2vh" }}
              error={errorMessage?.pickupQuantity}
              helperText={errorMessage?.pickupQuantity}
              type="number"
              label="Pick-up Quantity"
              onFocus={handleNumberFieldFocus}
              value={pickupQuantity}
              disabled
            // onChange={(e) => handlePickupQuantity(e)}
            // onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '-' || evt.key === '+') && evt.preventDefault()}
            />
          </Grid>
          <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button onClick={allocateQuantity}>Compute Quantity from below heaps</Button>
          </Grid></Grid>}
        <Typography sx={{ color: "red" }} gutterBottom>{errorMessage.rbCbWeightError}</Typography>
        <Typography sx={{ color: "red", mt: 1 }} gutterBottom>{errorMessage.totalWeightError}</Typography>
        <Box style={{ height: 400, width: '100%' }}>
          <DataGrid rows={heapDetails ? heapDetails : []}
            columns={props.heapsList == null ? columns : columns2}
            pageSize={10}
            getRowId={(row) => row?.id}
            components={{ Toolbar: QuickSearchToolbar }}
            slots={{
              footer: <Typography>Total: </Typography>,
            }}
          />
        </Box>
        <Box display='flex' alignItems="center" justifyContent="center" mt={3} mb={2} style={{ float: "right", marginBottom: "3vh" }}>
          <Button variant="contained" sx={{ minWidth: 100 }}
            onClick={props?.handleLogModalClose}
          >Cancel</Button>
          <Button sx={{ minWidth: 100, ml: 1 }} variant="contained"
            onClick={(e) => { props.heapsList != null ? plantSubmit(e) : bambooSubmit(e) }}
            disabled={heapDetails?.length === 0}
          >Submit</Button>
        </Box>
      </Container>
    </>
  );
};
export default HeapPopOver;